<div class="fab-container" [style.flexDirection]="reverseColumnDirection ? 'column-reverse' : 'column'">
	<button id="createPayGroupBtn" mat-fab color="primary" class="fab-toggler" (click)="onCreate()">
		<app-icon id="add-floating-icon" [name]="'add'" [color]="'white'" [size]="'30'" [lineWidth]="'2px'"></app-icon>
	</button>
</div>
